const FETCH_STUDENTS = 'fetch_students';
const FETCH_STUDENTS_SIMPLY = 'fetch_students_simply';
const FETCH_STUDENT = 'fetch_student';
const FETCH_STUDENTS_CSV = 'fetch_student_csv';
const DELETE_STUDENT = 'delete_student';
const PERSIST_STUDENT = 'persist_student';
const CREATE_FILES_STUDENT = 'create_files_student';
const DELETE_FILE_STUDENT = 'delete_file_student';
const FETCH_FILES_STUDENT = 'fetch_files_student';
const FETCH_INTAKES_STUDENT = 'fetch_intakes_student';
const UPDATE_STUDENT = 'update_student';
const CREATE_INTAKE_STUDENT = 'create_intake_student';
export default {
    FETCH_STUDENTS,
    FETCH_STUDENTS_CSV,
    FETCH_STUDENTS_SIMPLY,
    FETCH_STUDENT,
    DELETE_STUDENT,
    UPDATE_STUDENT,
    PERSIST_STUDENT,
    FETCH_FILES_STUDENT,
    FETCH_INTAKES_STUDENT,
    DELETE_FILE_STUDENT,
    CREATE_FILES_STUDENT,
    CREATE_INTAKE_STUDENT,
};
